// NATIVE 
import * as React from 'react';



// INSTALLED 
import { Formik, Form } from 'formik';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';



// CUSTOM 
import { useDispatch } from 'react-redux';
import { SnackAlert } from '../../../SnackAlert';
import MultipleSnackbars from '../../../MultipleSnackbars';
import { closeSessionGlobal, validateResponse } from '../../../../commons/utils';
import { timeToClosedToast } from '../../../../commons/values';
import { ModalSessionExpired } from '../../../generics/ModalSessionExpired';
import validationSchema from '../../../terminal/terminal-control-tiempo-descansos/formModels/crear/validationSchema';
import formInitialValues from '../../../terminal/terminal-control-tiempo-descansos/formModels/crear/formInitialValues';
// import { CreateTerminalDescansos } from '../../../terminal/terminal-descansos/crear/CreateTerminalDescansos';
// import createTerminalFormModel from '../../../terminal/terminal-control-tiempo-descansos/formModels/crear/createTerminalDescansosFormModel';
import { storeCreateTerminalDescansos } from '../../../../store/terminal-descansos';
import createTerminalDescansosFormModel from '../../../terminal/terminal-control-tiempo-empleados/formModels/crear/createTerminalDescansosFormModel';
import { CreateTerminalDescansos } from '../../../terminal/terminal-control-tiempo-empleados/crear/CreateTerminalDescansos';
// import { storeCreateTerminalDescansos } from '../../../../store/terminal-descansos';







const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));


export const CreateDialogTerminalDescansos = (props:any) =>  {

  
  // USE DISPATCH 
  const dispatch = useDispatch();


  // USE STATE 
  const [alert_snack, setAlertSnack] = React.useState(false);
  const [percentaje_terminal, setPercentajeTerminal] = React.useState(0);
  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [messagesAlerts, setMessagesAlerts] = React.useState<string[]>([]); 
  const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);

  const [isSubmiting, setIsSubmiting] = React.useState<boolean>(false);

  const [txtBtnEditTerminal, setTxtBtnEditTerminal] = React.useState<string>('Crear Terminal');

  const [msgSnack, setMsgSnack] = React.useState({
      msg: '',
      status: 'success'
  });


  // PROPS 
  const{ open, handleCloseModalCrear } = props;

  
  // DATA MODELS 
  const { formId, formField } = createTerminalDescansosFormModel;
  const currentValidationSchema = validationSchema[0];


  //  USE EFFECT 
  React.useEffect(() => {
      setIsSubmiting(!open);
  }, [props]);

   
  // CONST FUNCTIONS 
  const handleClose = () => {
    handleCloseModalCrear(false);
  };


  const _handleSubmit = async(values:any, actions:any) => {


    setTxtBtnEditTerminal('Un Monento...')
    actions.setSubmitting(true);
    setIsSubmiting(true);

    const response = await dispatch( storeCreateTerminalDescansos(values, setPercentajeTerminal) );

   await setTxtBtnEditTerminal('Crear Terminal')

   await validateResponse(response, 'Crear Terminal', {
                           setMsgSnack,
                           setAlertSnack,
                           setModalSessionExpired,
                         }, true);


   

   setIsSubmiting(false);


     handleCloseModalCrear(false);
  
  }

 
  return (
    <React.Fragment>


        {/* *****************************************************************
          ******  COMPONENTS PARA MANEJAR MENSAJES DEL RESPONSE  **************
          *********************************************************************/}
          <ModalSessionExpired  open={modalSessionExpired}  />
          <MultipleSnackbars messagesList={messagesAlerts} position={"bottom-left"} autoClose={timeAlert} />
          <SnackAlert open={alert_snack} onclick={setAlertSnack} text={msgSnack.msg} severity={msgSnack.status}/>
        {/* ******************************************************************
          ******  COMPONENTS PARA MANEJAR MENSAJES DEL RESPONSE  **************
          *********************************************************************/}
      
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
           Crear Terminal Descansos
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
        
   
        <Grid  >
            <Formik 
              initialValues={formInitialValues}
              validationSchema={currentValidationSchema}
              onSubmit={_handleSubmit}>

              <>
              <Form id={formId}>
                <CreateTerminalDescansos formField={formField}/>

                <Button
                    disabled={isSubmiting}
                    style={{margin:5, float: 'right'}}
                    type="submit"
                    variant="contained"
                    color={ "primary"}
                  >
                    {
                      txtBtnEditTerminal
                    }
                </Button>
                </Form>
              </>

            </Formik>
        </Grid>
       
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}